import React, { useState, useEffect } from 'react';
import '../styles/AI.scss';
import ChatList from '../components/ChatList';
import ChatArea from '../components/ChatArea';
import useChat from '../hooks/useChat';
import { useTheme } from '../hooks/useTheme';
import addIconLight from '../assets/light/addIcon.svg';
import addIconDark from '../assets/dark/addIcon.svg';
import sendMessageIcon from '../assets/light/sendMessageIcon.svg';
import { useNotification } from '../components/NotificationProvider';

const AI: React.FC = () => {
  const { chats, activeChat, isLoading, error, createChat, selectChat, sendMessage } = useChat();
  const [isChatListVisible, setIsChatListVisible] = useState(false);
  const { theme } = useTheme();
  const { showNotification } = useNotification();

  useEffect(() => {
    if (error) {
      showNotification(error);
    }
  }, [error, showNotification]);

  const toggleChatList = () => {
    setIsChatListVisible(!isChatListVisible);
  };

  return (
    <div className="ai-page">
      <div className="ai-header">
        <button 
          className="toggle-chat-list" 
          onClick={toggleChatList}
          aria-label="Показать список чатов"
        >
          ≡
        </button>
        <h1>Чат с ИИ-помощником</h1>
      </div>
      
      <div className="ai-container">
        <ChatList 
          chats={chats} 
          activeChat={activeChat} 
          selectChat={selectChat} 
          isVisible={isChatListVisible}
          onClose={() => setIsChatListVisible(false)}
        />
        
        <ChatArea 
          activeChat={activeChat} 
          isLoading={isLoading} 
          sendMessage={sendMessage} 
        />
        
        {/* Overlay для закрытия панели по клику вне */}
        {isChatListVisible && (
          <div 
            className="chat-list-overlay" 
            onClick={() => setIsChatListVisible(false)}
          />
        )}
      </div>
      
      {isChatListVisible && (
        <button 
          className="create-chat-button"
          onClick={() => {
            createChat();
            setIsChatListVisible(false);
          }}
          aria-label="Создать новый чат"
        >
          <img 
            src={theme === 'light' ? addIconLight : addIconDark} 
            alt="" 
            width="48" 
            height="48" 
          />
        </button>
      )}
    </div>
  );
};

export default AI; 